module.exports = __webpack_public_path__ + "static/img/cha2.cdbcd61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha2.png
// module id = vzTm
// module chunks = 1